<template>
  <canvas
    ref="pieCanvas"
    style="height: 100%; width: 100%"
    :style="stylePieChart"
  ></canvas>
</template>

<script lang="ts">
import {
  Chart,
  ChartOptions,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  PieController,
  ChartData
} from 'chart.js';
import type { PropType, StyleValue } from 'vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { optionsPieChart, leaderLinePlugin } from './configs';

Chart.register(
  PieController,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels
);

export default {
  name: 'PieChart',
  props: {
    dataPieChart: {
      type: Object as PropType<ChartData<'pie'>>,
      required: true
    },
    stylePieChart: {
      type: [Object, String] as PropType<StyleValue>,
      default: () => ({})
    }
  },
  emits: ['segment-click'],
  /* eslint-disable */
  data() {
    return {
      chart: null as any,
      optionsPieChart
    };
  },
  mounted() {
    (this as any).initChart();
  },
  methods: {
    getKeyByTranslatedLabel(
      translatedLabel: string,
      mapping: Record<string, string>
    ) {
      return Object.keys(mapping).find(
        (key) => mapping[key] === translatedLabel
      );
    },
    getLabel(points: any) {
      const firstPoint = points[0];
      const index = firstPoint.index;

      const label = (this as any).chart.data.labels[index];

      const labelsMap = {
        GOOD: (this as any).$t('happy'),
        OK: (this as any).$t('ok'),
        BAD: (this as any).$t('angry')
      };

      const key = this.getKeyByTranslatedLabel(label, labelsMap);

      (this as any).$emit('segment-click', { key });
    },
    initChart() {
      if ((this as any).chart) {
        (this as any).chart.destroy();
        (this as any).chart = null;
      }

      const canvas = (this as any).$refs.pieCanvas as HTMLCanvasElement;
      if (!canvas) return;

      const isCustomerReport =
        (this as any).$route.name === 'CustomersSatisfactionReport';

      const options: ChartOptions<'pie'> = optionsPieChart(isCustomerReport);

      if (isCustomerReport) {
        options.onClick = (event: any) => {
          const points = (this as any).chart.getElementsAtEventForMode(
            event,
            'nearest',
            { intersect: true },
            false
          );
          if (points.length) {
            (this as any).getLabel(points);
          }
        };
      }

      options.animation = false;
      options.animations = {};

      options.plugins!.title!.text = (this as any).$t('generalSatisfaction');
      options.plugins!.legend!.labels!.padding = isCustomerReport ? 30 : 10;
      options.plugins!.title!.padding = {
        bottom: isCustomerReport ? 30 : 10
      };

      (this as any).chart = new Chart(canvas, {
        type: 'pie',
        data: (this as any).dataPieChart,
        options,
        plugins: [ChartDataLabels, leaderLinePlugin(isCustomerReport)]
      });
    }
  },
  beforeUnmount() {
    if ((this as any).chart) {
      (this as any).chart.destroy();
    }
  },
  watch: {
    dataPieChart: {
      handler() {
        (this as any).initChart();
      },
      deep: true
    }
  }
};
</script>
